export const ERROR_TYPES = {
  JAVASCRIPT_DISABLED: 'disabledJavascript',
  ROTATE_DEVICE: 'rotateDevice',
  NOT_FOUND: 'notFound',
  UNSUPPORTED_BROWSER: 'unsupportedBrowser',
  SOCIAL_BROWSER: 'socialBrowser',
  UPGRADE_BROWSER: 'upgradeBrowser',
  WINDOW_TOO_SMALL: 'windowTooSmall',
};
